import { Box, ClickAwayListener, Tooltip, useTheme } from "@mui/material";
import { IconCircleInfo } from "components/icons/IconCircleInfo";
import React from "react";

export const DashTooltipClickable: React.FC<{ tooltip: string; }> = ({ tooltip }) => {

    const [open, setOpen] = React.useState(false);

    const theme = useTheme();

    const handleTooltipClose = () => {
      setOpen(false);
    };
  
    const handleTooltipOpen = () => {
      setOpen(true);
    };

    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={tooltip}
                slotProps={{
                    popper: {
                        disablePortal: true,
                    },
                }}
            >
                <Box 
                    display={"inline"} 
                    sx={{ cursor: "pointer", marginLeft: "4px" }} 
                    onClick={handleTooltipOpen}
                    color={theme.palette.muted.main}
                >
                    <IconCircleInfo size="1x"  />
                </Box>
            </Tooltip>                
          </ClickAwayListener>   
        );
}